export default {
  okmain:{
    lang:"English",
    openkylinweburl:'https://www.openkylin.top/index-en.html',
    openkylinsigurl:'https://www.openkylin.top/sig/application-en.html',
    openkylinmemberurl:'https://www.openkylin.top/community/partner-en.html',
    nav1:"Overview",
    nav2:"Contribution",
    nav3:"Official Website",
    user:"Users",
    contributors:"Contributors",
    member:"Members",
    sig:"SIG",
    repositories:"Repositories",
    commits:"Commits",
    pr:"PR",
    issues:"Issues",
    f_copyright:"Copyright@openKylin 2023 ICP No. 15002470-12 Tianjin",
    f_garight:"No.12011602001167",
    f_code:"Gitee",
    f_joinmember:"Join Member",
    f_joinsig:"Join SIG",
    f_updatetime:"Update Time",
    f_frequency:"Frequency",
    f_times:"hours 1 time",
    c_devel_contribute:"Developer Contributions",
    c_time1:'Last Month',
    c_time2:'Past Half Year',
    c_time3:'Last Year',
    c_all:'All',
    c_metrics:'Metrics',
    c_points:'Points',
    c_range:'Display Range',
    c_sort:'#',
    // Sorting
    c_giteename:"Gitee Name",
    c_communityname:"Community Name",
    c_contributionvalue:"Contribution Value",
    c_pointvalue:"Point Value",
  }
};



// WEBPACK FOOTER //
// ./src/local/language/en.js